var map = {
	"./Animation1.json": 9306,
	"./Animation10.json": 8838,
	"./Animation11.json": 7441,
	"./Animation12.json": 7812,
	"./Animation13.json": 5847,
	"./Animation14.json": 7773,
	"./Animation2.json": 331,
	"./Animation3.json": 8920,
	"./Animation4.json": 8129,
	"./Animation5.json": 7094,
	"./Animation6.json": 8135,
	"./Animation7.json": 2740,
	"./Animation8.json": 253,
	"./Animation9.json": 3522,
	"./BirdyLanding.json": 4198,
	"./CollabLanding.json": 4649,
	"./Error404.json": 6469,
	"./JourneyLanding.json": 1028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;